import { render, staticRenderFns } from "./reports.configure.component.vue?vue&type=template&id=a1570134&scoped=true&"
import script from "./reports.configure.component.vue?vue&type=script&lang=js&"
export * from "./reports.configure.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1570134",
  null
  
)

export default component.exports